import auth from './auth';
import member from './member';
import noticeSystem from './noticeSystem';
import settingAccount from './settingAccount';
import connect from './dataLink';
import exportDataShare from './exportDataShare';
import share from './share';
import dataLinkMulti from './dataLinkMulti';
import mail from './mail';
import settingField from './settingField';
import upload from './upload';
export default {
    auth,
    member,
    noticeSystem,
    settingAccount,
    connect,
    share,
    dataLinkMulti,
    mail,
    settingField,
    exportDataShare,
    upload
};
